import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-grey-1 q-pa-lg" }
const _hoisted_2 = { class: "text-h6 q-mb-md q-mt-none" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-weight-regular" }, "Step 1:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-body1" }, " When you click the button below, you will be redirected to Salesforce and prompted to install the Private Footprint application into your organization. ", -1)
const _hoisted_5 = { class: "text-h6 q-mb-md q-mt-none" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-weight-regular" }, "Step 2:", -1)
const _hoisted_7 = { class: "text-h6 q-mb-md q-mt-none" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-weight-regular" }, "Step 3:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-body1" }, " When you click the button below, you will be redirected to Salesforce and prompted to grant Private Footprint access to your Salesforce account. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_CreateServiceAccount = _resolveComponent("CreateServiceAccount")!
  const _component_ApiKey = _resolveComponent("ApiKey")!
  const _component_MaskedApiKey = _resolveComponent("MaskedApiKey")!
  const _component_AddProfile = _resolveComponent("AddProfile")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: `${_ctx.preset.label} Installation`,
    "body-style": {padding: 0},
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_card, { class: "q-mt-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_2, [
                  _createVNode(_component_q_icon, {
                    name: "fa fa-plus",
                    class: "on-left"
                  }),
                  _hoisted_3,
                  _createTextVNode(" Add Private Footprint to Litify ")
                ]),
                _hoisted_4,
                _createVNode(_component_q_btn, {
                  icon: "fa fa-plus",
                  label: "Add Private Footprint to Litify",
                  rounded: "",
                  class: "full-width q-mt-lg"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_card, { class: "q-mt-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_5, [
                  _createVNode(_component_q_icon, {
                    name: "fa fa-cog",
                    class: "on-left"
                  }),
                  _hoisted_6,
                  _createTextVNode(" Configure Litify ")
                ]),
                _createVNode(_component_CreateServiceAccount, {
                  "account-id": _ctx.accountId,
                  "integration-type": _ctx.preset.type,
                  onCreated: _cache[0] || (_cache[0] = ($event: any) => (_ctx.serviceAccount = $event))
                }, null, 8, ["account-id", "integration-type"]),
                (_ctx.serviceAccount && _ctx.serviceAccount.apiKey)
                  ? (_openBlock(), _createBlock(_component_ApiKey, {
                      key: 0,
                      value: _ctx.serviceAccount.apiKey
                    }, null, 8, ["value"]))
                  : (_ctx.serviceAccount)
                    ? (_openBlock(), _createBlock(_component_MaskedApiKey, {
                        key: 1,
                        "service-account": _ctx.serviceAccount,
                        "onUpdate:serviceAccount": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.serviceAccount) = $event))
                      }, null, 8, ["service-account"]))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_card, { class: "q-mt-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_7, [
                  _createVNode(_component_q_icon, {
                    name: "fa fa-lock",
                    class: "on-left"
                  }),
                  _hoisted_8,
                  _createTextVNode(" Grant Access to Salesforce ")
                ]),
                _hoisted_9,
                (_ctx.serviceAccount)
                  ? (_openBlock(), _createBlock(_component_AddProfile, {
                      key: 0,
                      type: "salesforce_user",
                      "account-id": _ctx.accountId,
                      onAdded: _ctx.onProfileAdded,
                      class: "q-mt-lg"
                    }, null, 8, ["account-id", "onAdded"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}